import React from 'react';
import get from 'lodash/get';
import kebabCase from 'lodash/kebabCase';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Flyout } from '@els/els-react--flyout';
import { ButtonWithIcon, Button } from '@els/els-react--button';
import InnerHTML from '@Components/InnerHTML';

function FindSimilarModalContent(props) {
  const { data, itemsForDb, goTo } = props;
  const information = get(data, 'information');
  const image = get(data, 'image');

  return (
    <div className="find-similar-modal__content">
      <InnerHTML className="find-similar-modal__content_title" tag="div" html={information} />
      <div className="find-similar-modal__content_table rx-newmodal-content rx-newmodal-content-main">
        <table className="rx-table rx-table--full-width find-similar-table">
          <thead>
            <tr>
              <th scope="col">{image && image.label}</th>
              {itemsForDb.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <th scope="col" key={`find-similar-table-th-${index}`}>
                  <div className="find-similar-table__col">
                    {item.description}
                    <Flyout
                      className="u-els-margin-left-1o4"
                      flyout={<div className="find-similar-table__dropdown u-els-font-size-base u-els-color-text">{item.help}</div>}
                      shouldCloseOnESC
                      showCloseButton
                      placement="bottom-start"
                      pointerType="primary">
                      <ButtonWithIcon
                        data-e2e={`find-similar-help-${kebabCase(item.description)}`}
                        sprite="HelpOutlineCircle"
                        iconOnly
                        type="link"
                        linkIconSize="xs"
                        className={cn('e2e-dropdown', `e2e-${kebabCase(item.description)}`)}
                        onClick={noop}>
                        item.description
                      </ButtonWithIcon>
                    </Flyout>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="rx-table__cell--no-pad">
                {image && image.url && (
                  <div className="find-similar-table__image-container">
                    {}
                    <img className="find-similar-table__image-container_image" src={image.url} alt="find-similar-image" />
                  </div>
                )}
              </td>
              {itemsForDb.map((item, index) => {
                const resultSize = get(item, 'resultSize');
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <td key={`find-similar-table-td-${index}`}>
                    {resultSize && resultSize !== 0 ? (
                      <Button
                        data-e2e="find-similar-modal-go-to"
                        className="e2e-find-similar-modal-goTo"
                        type="link"
                        data-testid="result-size-button"
                        role="button"
                        onClick={() => goTo(item)}>
                        {resultSize?.toLocaleString()}
                      </Button>
                    ) : (
                      <span>{resultSize}</span>
                    )}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

FindSimilarModalContent.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    information: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
      label: PropTypes.string,
    }),
  }),
  goTo: PropTypes.func.isRequired,
  itemsForDb: PropTypes.array,
};

export default FindSimilarModalContent;
